<!--
 * @Descripttion: vue-json-editor
 依赖: json-editor https://github.com/josdejong/jsoneditor/tree/master/examples
 * @Author: zenghua.wang
 * @Date: 2021-04-19 13:24:22
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-09-24 14:37:42
-->
<template>
  <div style="height:100%">
    <div class="jsoneditor-container"></div>
    <div class="jsoneditor-btns" v-if="showBtns">
      <el-button type="primary" @click="onSubmit" :disabled="error">确定</el-button>
    </div>
  </div>
</template>

<script>
import JsonEditor from 'jsoneditor'
import 'jsoneditor/dist/jsoneditor.css'
import { fixChromeZoom } from '@/dragComponents/utils'

export default {
  props: {
    value: [String, Number, Object, Array],
    showBtns: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    expandedOnStart: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'text'
    },
    modes: {
      type: Array,
      default: function () {
        return [] // ["tree", "code", "form", "text", "view"];
      }
    },
    lang: {
      type: String,
      default: 'en'
    }
  },
  watch: {
    value: {
      immediate: true,
      async handler(val) {
        if (!this.internalChange) {
          await this.setEditor(val)
          this.error = false
          this.expandAll()
        }
      },
      deep: true
    }
  },
  data() {
    return {
      editor: null,
      error: false,
      json: this.value,
      internalChange: false,
      expandedModes: ['tree', 'view', 'form']
    }
  },
  mounted() {
    let self = this

    let options = {
      search: false,
      mode: this.mode,
      modes: this.modes, // allowed modes
      onEditable() {
        return self.editable
      },
      onChange() {
        try {
          let json = self.editor.get()
          self.json = json
          self.error = false
          self.$emit('json-change', json)
          self.internalChange = true
          self.$emit('input', json)
          self.$nextTick(function () {
            self.internalChange = false
          })
        } catch (e) {
          self.error = true
          self.$emit('has-error', e)
        }
      },
      onModeChange() {
        self.expandAll()
      }
    }

    let dom = this.$el.querySelector('.jsoneditor-container')
    fixChromeZoom(dom)
    this.editor = new JsonEditor(dom, options, this.json)
  },
  methods: {
    expandAll() {
      if (
        this.expandedOnStart &&
        this.expandedModes.includes(this.editor.getMode())
      ) {
        this.editor.expandAll()
      }
    },
    onSubmit() {
      this.$emit('json-save', this.json)
    },
    async setEditor(value) {
      if (this.editor) this.editor.set(value)
    }
  }
}
</script>

<style scoped lang="scss">
:deep(
    .jsoneditor-sort,
    .jsoneditor-transform,
    .jsoneditor-repair,
    .jsoneditor-poweredBy
  ) {
  display: none;
}
:deep(.jsoneditor-menu) {
  background-color: #3b9cd9;
}
:deep(textarea.jsoneditor-text) {
  padding: 20px;
  min-height: 600px;
}

.jsoneditor {
  &-container {
    height: 90%;
  }

  &-btns {
    padding: 20px;
  }
}
</style>
